import React from 'react'
import useSWR from 'swr'
import { fetchPaymentDetails } from '@library/api-payment'
import { Accordion, Text } from '@gousto-internal/citrus-react'
import { RenderedTitle } from '../../RenderedTitle'

export const PaymentCardSection = ({ userId }: any) => {
  const { data } = useSWR(userId, fetchPaymentDetails)
  return (
    <>
      <Accordion
        id={'payment-details-accordion'}
        title={(isExpanded) => {
          switch (data?.method) {
            case 'card':
              const paymentCardNumber = data?.details.number
              return (
                <RenderedTitle isExpanded={isExpanded} title="Card" iconType="credit_card">
                  <Text size={2}>{paymentCardNumber}</Text>
                </RenderedTitle>
              )
              break
            case 'paypal':
              return (
                <RenderedTitle isExpanded={isExpanded} title="Paypal" iconType="credit_card">
                  <Text>PayPal</Text>
                </RenderedTitle>
              )
              break
            case 'applepay':
              return (
                <RenderedTitle isExpanded={isExpanded} title="ApplePay" iconType="credit_card">
                  <Text>Apple Pay</Text>
                </RenderedTitle>
              )
              break
            default:
              return (
                <RenderedTitle isExpanded={isExpanded} title="Card" iconType="credit_card">
                  <Text size={2}>No payment data found</Text>
                </RenderedTitle>
              )
          }
        }}
      >
        <Text>Edit Content</Text>
      </Accordion>
    </>
  )
}
